import api from "./api";

export const getAllSnmpAuthProfiles = async (schemaName = null) => {
  try {
    const response = await api.get("/snmp-auth-profiles/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching SNMP auth profiles:", error);
    throw error;
  }
};

export const getSnmpAuthProfileById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/snmp-auth-profiles/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching SNMP auth profile:", error);
    throw error;
  }
};

export const createSnmpAuthProfile = async (data, schemaName = null) => {
  try {
    const response = await api.post("/snmp-auth-profiles/", data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error creating SNMP auth profile:", error);
    throw error;
  }
};

export const updateSnmpAuthProfile = async (id, data, schemaName = null) => {
  try {
    const response = await api.patch(`/snmp-auth-profiles/${id}/`, data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error updating SNMP auth profile:", error);
    throw error;
  }
};

export const deleteSnmpAuthProfile = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/snmp-auth-profiles/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting SNMP auth profile:", error);
    throw error;
  }
};
